module.exports = __webpack_public_path__ + "static/media/switcherIcon.7fa199ab.svg";